import { useMemo } from 'react'
import { useSessionStateStore } from '@renderer/stores/sessionState'

/**
 * The session's photographs, in slot order, with the chosen filter applied.
 *
 * `capturedItems` is not only photographs — the strip, the gif and the framed
 * video are appended to the same array as the session goes on, so anything that
 * renders "the photos" has to exclude them or the strip ends up inside itself.
 *
 * `filteredVersions` is populated in the background after each shot, so a fresh
 * photograph falls back to its raw URL until the bake lands rather than showing
 * a hole.
 */
export function useBkPhotos(): (string | undefined)[] {
  const capturedItems = useSessionStateStore((s) => s.gallery?.capturedItems)
  const filterId = useSessionStateStore((s) => s.userPreferences?.filterId)

  return useMemo(
    () =>
      (capturedItems ?? [])
        .filter((item) => !item.id?.includes('dreambooth-strip') && !item.videoUrl && !item.gifUrl)
        .map((item) => (filterId && item.filteredVersions?.[filterId]) || item.photoUrl),
    [capturedItems, filterId]
  )
}
